export function elementHasNoTextContent(element) {
  const elementText = element.innerHTML;
  const hasNoNonTextChildren = element.childElementCount === 0;
  const hasNoRealText =
    elementText.length === 0 || !!elementText.match(/^(&nbsp;)+$/g);

  return hasNoRealText && hasNoNonTextChildren;
}
